import ListErrors from './widgets/ListErrors'
import React from 'react'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  REGISTER,
  REGISTER_PAGE_UNLOADED,
  REGISTER_PAGE_GETPINCODE,
  REDIRECT
} from '../constants/actionTypes'
import Phone from 'react-phone-number-input'
// import { parseNumber, formatNumber, isValidNumber } from 'libphonenumber-js'
import { Translation } from 'react-i18next'
import i18n from '../languages/lang.js'

const mapStateToProps = state => ({
  ...state.auth,
  marketData: state.common.marketData,
  inProgress: state.common.inProgress,
  userInfo: state.router.location.state ? state.router.location.state.userInfo : null,
})

const mapDispatchToProps = dispatch => ({
  onGetPinCode: (mobile) => {
    const payload = agent.Auth.getPinCode(mobile, 'register')
    dispatch({ type: REGISTER_PAGE_GETPINCODE, payload })
  },
  onSubmit: (payload, issuer_type) =>
    dispatch({ type: REGISTER, payload, issuer_type }),
  onUnload: () =>
    dispatch({ type: REGISTER_PAGE_UNLOADED }),
  onRedirect: () =>
    dispatch({ type: REDIRECT })
})

class RegisterVerifyPhone extends React.Component {
  constructor() {
    super()
    this.state = {
      firstname: '',
      lastname: '',
      phone: '',
      password: '',
      code: '',
      type: '',
      countDownText: i18n.t('system.verify_mobile'),
      countDownDisabled: false
    }
    this.updateState = field => ev => {
      const state = this.state
      const newState = Object.assign({}, state, { [field]: ev.target.value })
      this.setState(newState)
    }
    this.getPinCode = (mobile) => ev => {
      ev.preventDefault()
      this.setState({ countDownDisabled: true })
      this.props.onGetPinCode(mobile)
      let seconds = 59
      this.timer = setInterval(() => {
        seconds--
        this.setState({ countDownText: i18n.t('authentication.verification_retry_after', { seconds: seconds }) })
        if (seconds <= 0) {
          this.timer && clearInterval(this.timer)
          this.setState({ countDownText: i18n.t('authentication.retry_verify_mobile'), countDownDisabled: false });
        }
      }, 1000)
    }
    this.submitForm = (phone, code) => ev => {
      ev.preventDefault()
      const firstname = this.state.firstname
      const lastname = this.state.lastname
      const email = this.state.email
      const password = this.state.password
      const referrer = this.state.referrer
      const type = this.state.type
      const payload = agent.Auth.register(firstname, lastname, phone, email, password, referrer, code, type)
      const issuer_type = this.state.issuer_type
      this.props.onSubmit(payload, issuer_type)
    }
  }
  componentWillMount() {
    if (this.props.userInfo) {
      Object.assign(this.state, {
        firstname: this.props.userInfo.firstname,
        lastname: this.props.userInfo.lastname,
        phone: this.props.userInfo.phone,
        email: this.props.userInfo.email,
        password: this.props.userInfo.password,
        referrer: this.props.userInfo.referrer,
        type: this.props.userInfo.type,
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      store.dispatch(push(nextProps.redirectTo))
      this.props.onRedirect()
    }
  }
  componentWillUnmount() {
    this.timer && clearTimeout(this.timer)

    this.props.onUnload()
  }

  render() {
    const phone = this.state.phone
    const code = this.state.code
    const inProgress = this.props.inProgress
    return (
      <Translation>
        {
          (t, { i18n }) => (
            <div id="focus">
              <div id="focus-header"><h1>{t('system.name')}</h1></div>
              <div className="main">
                <div className="main-wrap">
                  <div className="focus-wrap">
                    <div className='box-header'>
                      <h2>{t('authentication.verification_sms_title')}</h2>
                    </div>
                    {
                      !this.props.phone_errors && this.props.sms_requested ?
                        <div id='message'>{t('authentication.verification_sms_message')}</div>
                        : null
                    }
                    <div className="form-item">
                      <label>{t('input_label.phone')}</label>
                      <input type="text" placeholder="+60100000000" value={phone} onChange={this.updateState('phone')} />
                    </div>
                    <div className="form-item">
                      <label>{t('input_label.verification_code')}</label>
                      <input type="text" value={code} onChange={this.updateState('code')} />
                    </div>
                    <ListErrors errors={this.props.phone_errors} />
                    <ListErrors errors={this.props.errors} />

                    <div className="form-item">
                      <button onClick={this.getPinCode(phone)} disabled={this.state.countDownDisabled ? 'disabled' : ''}>{this.state.countDownText}</button>
                    </div>
                    <div>
                      {
                        code.length === 6 ?
                          <div className="form-item">
                            <button
                              onClick={this.submitForm(phone, code)}
                              disabled={this.props.inProgress}>
                              {inProgress ? t('authentication.register_button_progress') : t('authentication.register_complete_button')}
                            </button></div> : null
                      }
                    </div>

                  </div>
                </div>
              </div>
            </div>
          )
        }
      </Translation>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterVerifyPhone)
